import { useState } from 'react'
import styles from './EditTempPkomModal.module.scss'
// Material-UI imports
import { Modal } from '@material-ui/core'
import {
  leftInputArrowIcon,
  rightInputArrowIcon,
  submitButtonCheck,
  sunSmallIcon,
  iceSmallIcon
} from 'icons'
const EditTempPkomModal = props => {
  const { hideModal, translate, system, updatePkomClimaConsign } = props
  const { controlPkom } = system
  const { clima } = controlPkom
  const { consignTemp, consignTempCooling } = clima

  const [refreshingTemp, setRefreshingTem] = useState(consignTempCooling || 0)
  const [heatingTemp, setHeatingTemp] = useState(consignTemp || 0)

  const [open] = useState(true)

  const handleForm = e => {
    e.preventDefault()
    updatePkomClimaConsign({
      _id: system._id,
      consignTempSummer: refreshingTemp,
      consignTempWinter: heatingTemp
    })
    hideModal()
  }

  return (
    <div>
      <Modal
        open={open}
        onClose={hideModal}
        arial-labelledby='simple-modal-title'
        arial-desccribedby='simple-modal-description'
      >
        <div className={styles.centered}>
          <div className={styles.modal}>
            <span className={styles.title}>{translate('temperatureControl')}</span>
            <div className={styles.form_titles}>
              <span>{translate('mode')}</span>
              <span>{translate('temperatureControl')}</span>
            </div>
            <form>
              <div className={styles.form_block}>
                <div className={styles.aligned}>
                  <div className={styles.small_icon_wrapper}>
                    <img
                      src={sunSmallIcon}
                      alt={translate('refreshingTemp')}
                    />
                  </div>
                  <span>{translate('refreshingTemp')}</span>
                </div>
                <div className={styles.aligned}>
                  <div
                    className={styles.icon_wrapper}
                    onClick={() => {
                      setRefreshingTem(prev => prev - 1)
                    }}
                  >
                    <img
                      src={leftInputArrowIcon}
                      alt='Temperature DOWN'
                    />
                  </div>
                  <input
                    className={styles.tempInput}
                    value={refreshingTemp}
                    onChange={e => setRefreshingTem(e.target.value)}
                  />
                  <div
                    className={styles.icon_wrapper}
                    onClick={() => {
                      setRefreshingTem(prev => prev + 1)
                    }}
                  >
                    <img
                      src={rightInputArrowIcon}
                      alt='Temperature UP'
                    />
                  </div>
                </div>
              </div>
              <div className={styles.form_block}>
                <div className={styles.aligned}>
                  <div className={styles.small_icon_wrapper}>
                    <img
                      src={iceSmallIcon}
                      alt={translate('heatingTemp')}
                    />
                  </div>
                  <span>{translate('heatingTemp')}</span>
                </div>
                <div className={styles.aligned}>
                  <div
                    className={styles.icon_wrapper}
                    onClick={() => {
                      setHeatingTemp(prev => prev - 1)
                    }}
                  >
                    <img
                      src={leftInputArrowIcon}
                      alt='Temperature DOWN'
                    />
                  </div>
                  <input
                    className={styles.tempInput}
                    value={heatingTemp}
                    onChange={e => setHeatingTemp(e.target.value)}
                  />
                  <div
                    className={styles.icon_wrapper}
                    onClick={() => {
                      setHeatingTemp(prev => prev + 1)
                    }}
                  >
                    <img
                      src={rightInputArrowIcon}
                      alt='Temperature UP'
                    />
                  </div>
                </div>
              </div>
              <div className={styles.alignSubmit}>
                <button
                  className={styles.submitButton}
                  onClick={handleForm}
                >
                  <img src={submitButtonCheck} />
                  {translate('applyChanges')}
                </button>
              </div>
            </form>
          </div>
        </div>
      </Modal>
    </div>
  )
}
export default EditTempPkomModal
